module.exports = {
  // app_url: "https://dedicatedtestserver.com:8101",
  app_url: "https://services.etijwaal.com",
  // app_url: "http://192.168.18.160:2424",
  // app_url: "http://192.168.18.94:2424", //FARAZ
};
